import CardBroken from "@components/HomePage/CardParts/CardBroken";
import CardError from "@components/HomePage/CardParts/CardError";
import CardNotLoaded from "@components/HomePage/CardParts/CardNotLoaded";
import CardUnpublished from "@components/HomePage/CardParts/CardUnpublished";
import CardCloneProgress from "@components/HomePage/CardParts/CloneProgress";
import type { CardState } from "@components/HomePage/CardParts/getCardState";
import CatalogFetchNotification from "@ext/git/actions/Fetch/CatalogFetchNotification";
import type { RemoteProgressPercentage } from "@ext/git/core/GitCommands/model/GitCommandsModel";
import type { CatalogLink } from "@ext/navigation/NavigationLinks";
import { ProgressBlockTemplate } from "@ui-kit/Progress";

export interface CardStateFooterProps {
	state: CardState;
	link: CatalogLink;
	progress: RemoteProgressPercentage | null;
	isCancel: boolean;
	setIsCancel: (isCancel: boolean) => void;
	onCloneClick: () => void;
	/** Whether the user may cancel the clone, drop its failure or remove the catalog; the server refuses the others. */
	canManageClone: boolean;
	onErrorClick: () => void;
}

const CardStateFooter = ({
	state,
	link,
	progress,
	isCancel,
	setIsCancel,
	onCloneClick,
	canManageClone,
	onErrorClick,
}: CardStateFooterProps) => {
	switch (state) {
		case "ready":
		case "broken":
			return <CatalogFetchNotification catalogLink={link} />;
		case "unpublished":
			return <CardUnpublished />;
		case "not-loaded":
			return <CardNotLoaded onClone={onCloneClick} />;
		case "opening":
			return (
				<div className="w-full -mb-1">
					<ProgressBlockTemplate data-qa="loader" indeterminate size="sm" />
				</div>
			);
		case "cloning":
		case "space-cloning":
			return (
				<CardCloneProgress
					canCancel={canManageClone}
					isCancel={isCancel}
					name={link.name}
					progress={progress}
					setIsCancel={setIsCancel}
				/>
			);
		case "clone-failed":
			return canManageClone ? <CardBroken link={link} /> : <CardError />;
		case "clone-error":
			return <CardError onRemove={canManageClone ? onErrorClick : undefined} />;
		default: {
			const unknown: never = state;
			return unknown;
		}
	}
};

export default CardStateFooter;
